import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import React__default, { useCallback } from 'react';
import { Skeleton } from './Skeleton.js';
import '../../skeleton.module-7c98b8f8.js';

var styles = {"logo":"InstitutionLogo_logo_7c7afa49","small":"InstitutionLogo_small_7c7afa49","large":"InstitutionLogo_large_7c7afa49","skeleton":"InstitutionLogo_skeleton_7c7afa49","clickable":"InstitutionLogo_clickable_7c7afa49","focus-visible":"InstitutionLogo_focus-visible_7c7afa49","indicator":"InstitutionLogo_indicator_7c7afa49"};

var colors = [
    "#39A775",
    "#28A2B9",
    "#3E97F8",
    "#6164EA",
    "#9A65E7",
    "#E75A85",
    "#F5923E", // Orange
];
var colorMap = {};
var InstitutionLogo = React__default.forwardRef(function InstitutionLogo(_a, ref) {
    var _b;
    var _c = _a.institution, institution = _c === void 0 ? {} : _c, _d = _a.variant, variant = _d === void 0 ? "medium" : _d, className = _a.className, _e = _a.isSkeleton, isSkeleton = _e === void 0 ? false : _e, indicator = _a.indicator, onClick = _a.onClick, dataTestId = _a.dataTestId, ariaLabel = _a.ariaLabel, props = __rest(_a, ["institution", "variant", "className", "isSkeleton", "indicator", "onClick", "dataTestId", "ariaLabel"]);
    var isUnknown = !(institution === null || institution === void 0 ? void 0 : institution.name);
    var institutionName = (institution === null || institution === void 0 ? void 0 : institution.name) || "Unknown";
    var _f = institution.logo || {}, logoUrl = _f.src, _g = _f.alt, alt = _g === void 0 ? "" : _g;
    var institutionInitial = isUnknown && !logoUrl ? "?" : institutionName.substring(0, 1);
    var pickFromPalette = useCallback(function () {
        if (!colorMap[institutionName]) {
            var keyCount = Object.keys(colorMap).length;
            if (keyCount > colors.length - 1) {
                colorMap[institutionName] = colors[keyCount % colors.length];
            }
            else {
                colorMap[institutionName] = colors[keyCount];
            }
        }
        return colorMap[institutionName];
    }, [institutionName]);
    var testId = dataTestId !== null && dataTestId !== void 0 ? dataTestId : "institution-logo";
    var clickableProps = {
        role: "button",
        tabIndex: 0,
        onClick: onClick,
    };
    if (isSkeleton) {
        return (React__default.createElement(Skeleton, { className: classNames(styles.logo, styles.skeleton, styles[variant], className) }));
    }
    return (React__default.createElement("div", __assign({ className: classNames(styles.logo, styles[variant], (_b = {},
            _b[styles.clickable] = onClick,
            _b), className), "aria-label": ariaLabel, ref: ref }, (onClick ? clickableProps : {}), props, { "data-testid": testId, style: {
            backgroundColor: !logoUrl ? pickFromPalette() : undefined,
        } }),
        logoUrl ? (React__default.createElement("img", { src: logoUrl, alt: alt, "data-testid": "".concat(testId, "-image") })) : (institutionInitial),
        indicator && React__default.createElement("span", { className: styles.indicator }, indicator)));
});

export { InstitutionLogo };
